export const categories = [
  { slug: 'xuan-yi-jing-song', name: '悬疑惊悚', icon: 'ri-mist-line', description: '扣人心弦的心理博弈与暗黑叙事，适合追求智力挑战的成熟读者。' },
  { slug: 'du-shi-qing-gan', name: '都市情感', icon: 'ri-heart-line', description: '当代都市中复杂微妙的人际关系与情感纠葛，写实而深刻。' },
  { slug: 'li-shi-chuan-qi', name: '历史传奇', icon: 'ri-ancient-gate-line', description: '以历史为舞台的壮阔叙事，融合传奇色彩与人性深度。' },
  { slug: 'ke-huan-qi-huan', name: '科幻奇幻', icon: 'ri-rocket-line', description: '天马行空的想象世界，探讨人性、科技与未知的边界。' },
  { slug: 'yi-shu-xie-shi', name: '艺术写实', icon: 'ri-paint-brush-line', description: '以精妙画工和文学性叙事见长，兼具艺术收藏价值。' },
  { slug: 'hei-se-you-mo', name: '黑色幽默', icon: 'ri-emotion-laugh-line', description: '以荒诞讽刺的笔触解构现实，在笑声中体味人生百态。' },
];

export const allManga = [
  {
    id: '1',
    slug: 'an-ye-tian-tang',
    title: '暗夜天堂',
    author: '林雨轩',
    category: '悬疑惊悚',
    categorySlug: 'xuan-yi-jing-song',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20manga%20cover%20art%20with%20noir%20atmosphere%2C%20shadowy%20cityscape%20at%20night%2C%20a%20silhouetted%20figure%20standing%20under%20a%20streetlamp%2C%20deep%20red%20and%20black%20color%20scheme%2C%20Japanese%20seinen%20manga%20style%20illustration%2C%20cinematic%20lighting%2C%20highly%20detailed%20lineart%2C%20mature%20tone%2C%20professional%20cover%20design&width=800&height=1100&seq=manga-cover-01&orientation=portrait',
    rating: 4.8,
    ratingCount: 2356,
    description: '雨夜，一具无名女尸在高级公寓被发现。刑警方远深入调查，却发现每个嫌疑人都藏着不可告人的秘密。当真相一层层剥开，人性的黑暗面远比想象中更加触目惊心。这是一部融合了社会派推理与心理惊悚的杰作，画风冷峻，叙事节奏紧凑，被誉为近年最值得一读的悬疑成人漫画。',
    tags: ['悬疑', '心理', '社会派', '成人向'],
    publishDate: '2025-09-15',
    chapters: 48,
    status: '连载中',
    featured: true,
    latest: true,
    contentHtml: '<p>雨夜的城市浸泡在一片朦胧的水光之中，霓虹灯在积水中倒映出破碎的色彩。</p><p>方远站在公寓楼下的警戒线外，雨水顺着他的帽檐滴落。已经是凌晨两点，但围观的居民依旧不愿散去——在这个城市，高级公寓里发现无名女尸，足够成为整个街区未来三个月的谈资。</p><p>"方队，初步判断死亡时间在昨晚十点到十二点之间。"助手小林递过初步报告，"没有明显外伤，死因需要等法医那边。"</p><p>方远点点头，抬头望向十二楼那个亮着灯的窗户。那是死者的家，也是案发现场。在这个城市最繁华的地段，一扇窗户后面，藏着怎样的秘密？</p><p>电梯里，他闭上眼睛，脑海中已经开始构建案件的拼图。</p><p>死者叫苏婉清，三十二岁，某知名画廊的策展人。独居，社交圈复杂但不混乱，没有已知的仇人。初步排查，她最近正在筹备一场备受瞩目的当代艺术展，涉及金额巨大。</p><p>门开了。</p><p>公寓内部装修精致，北欧极简风格，处处透露出主人的品味。但此刻，这一切都被死亡的气息笼罩。</p><p>"方队，你看这个。"技术科的小张指着茶几上的一杯红酒，"杯子上有两个人的指纹，一个是死者的，另一个还没比对出来。"</p><p>方远走过去，仔细端详着那杯已经氧化的红酒。杯沿上有淡淡的唇印——不是死者的口红色号。这说明在死亡发生前，有另一个人在这里，和死者共饮。</p><p>而这个人，很可能就是最后的目击者。</p><p>或者——凶手。</p>',
  },
  {
    id: '2',
    slug: 'jing-ji-zhi-cheng',
    title: '荆棘之城',
    author: '沈墨白',
    category: '都市情感',
    categorySlug: 'du-shi-qing-gan',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20urban%20romance%20manga%20cover%2C%20a%20sophisticated%20woman%20in%20a%20modern%20city%20setting%2C%20warm%20amber%20and%20rose%20gold%20tones%2C%20soft%20atmospheric%20lighting%2C%20Japanese%20josei%20manga%20art%20style%2C%20delicate%20linework%2C%20emotional%20expression%2C%20luxurious%20aesthetic%2C%20professional%20cover%20design&width=800&height=1100&seq=manga-cover-02&orientation=portrait',
    rating: 4.6,
    ratingCount: 1892,
    description: '三十岁的投资银行副总裁顾安然，在事业巅峰期遭遇情感真空。一纸商业合作协议，让她与年轻画家陆辰的命运纠缠在一起。年龄、阶层、价值观的巨大差异，让这段感情布满荆棘。但当两个孤独的灵魂在都市丛林中相遇，谁能抵挡住内心最真实的渴望？',
    tags: ['都市', '情感', '年龄差', '写实'],
    publishDate: '2025-07-20',
    chapters: 36,
    status: '连载中',
    featured: true,
    latest: false,
    contentHtml: '<p>会议室里冷气开得很足，顾安然的指尖微微发凉，但她的眼神比会议室里任何一个男人都要坚定。</p><p>"这个收购方案，我有三点异议。"她将一份文件推到长桌中央，"第一，估值模型过于保守；第二，对目标公司核心人才的保留方案不够具体；第三——"</p><p>她顿了顿，目光扫过在场所有人。</p><p>"第三，你们低估了创始人对这个品牌的感情。"</p><p>会议结束后，她的助理小周小跑着跟上来："顾总，晚上七点和陆辰先生约了在湖畔餐厅，讨论艺术基金的项目。"</p><p>顾安然低头看了一眼手表。五点半。她还有一份报告要审，但脑子已经开始不太配合了。</p><p>陆辰。她默默念了一遍这个名字。</p><p>三十二岁，独立画家，作品已经在国际拍卖行崭露头角。但真正让她感兴趣的，是他最近提出的"城市记忆"系列——一组以都市女性为主题的大型油画。</p><p>湖畔餐厅的灯光柔和，陆辰比她早到了十分钟。他穿着一件简单的黑色毛衣，袖口沾着一点没洗干净的蓝色颜料。</p><p>"抱歉，刚从画室出来。"他笑了笑，眼角的细纹让他看起来比实际年龄更成熟一些。</p><p>"没关系。"顾安然在他对面坐下，"我喜欢准时的人。"</p><p>窗外的湖面被晚风吹起细碎的波纹，城市的灯光在远处闪烁。这一刻，他们都不是投资银行副总裁和独立画家，只是两个在都市夜晚寻找某种共鸣的普通人。</p>',
  },
  {
    id: '3',
    slug: 'da-tang-feng-yun-lu',
    title: '大唐风云录',
    author: '陈古月',
    category: '历史传奇',
    categorySlug: 'li-shi-chuan-qi',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20historical%20Chinese%20manga%20cover%2C%20Tang%20Dynasty%20warrior%20on%20horseback%2C%20ancient%20Chinese%20palace%20in%20background%2C%20gold%20and%20crimson%20color%20palette%2C%20ink%20wash%20painting%20style%20blended%20with%20modern%20manga%2C%20dramatic%20composition%2C%20detailed%20armor%20and%20silk%20robes%2C%20professional%20cover%20design&width=800&height=1100&seq=manga-cover-03&orientation=portrait',
    rating: 4.9,
    ratingCount: 3120,
    description: '安史之乱后的大唐，帝国余晖中暗流涌动。落魄书生苏子安意外卷入一场宫廷密谋，从此踏上波谲云诡的权谋之路。庙堂之高与江湖之远，忠诚与背叛，理想与现实——在历史的洪流中，每个人都必须做出自己的选择。画风融合了中国水墨意境与现代漫画技法，堪称视觉盛宴。',
    tags: ['历史', '权谋', '武侠', '史诗'],
    publishDate: '2025-05-10',
    chapters: 62,
    status: '连载中',
    featured: true,
    latest: false,
    contentHtml: '<p>至德二年的长安，空气中弥漫着一种说不清的味道——是烧焦的木头、腐烂的丝绸，还有久久不散的血腥。</p><p>苏子安站在残破的朱雀大街尽头，看着这座曾经世界上最繁华的城市。安禄山的铁骑来过又走了，留下的是一片狼藉和一个摇摇欲坠的帝国。</p><p>他今年二十四岁，科举落第，身无分文。唯一值钱的，是怀里那封已经皱巴巴的推荐信——他父亲生前唯一的朋友，现任户部侍郎的刘大人。</p><p>"让开！"马蹄声从身后传来，苏子安下意识往旁边一闪，一队骑兵从身边掠过，泥水溅了他一身。</p><p>他苦笑了一下。在这个乱世，一个书生的尊严，还比不上马蹄下的泥水。</p><p>但他不知道的是，命运的齿轮已经开始转动。当他走进刘府的那一刻，他就已经被卷入了一场远比安史之乱更加险恶的博弈之中。</p><p>而这场博弈的赌注，是整个大唐的未来。</p>',
  },
  {
    id: '4',
    slug: 'xing-yuan-di-ping-xian',
    title: '星渊地平线',
    author: '叶星辰',
    category: '科幻奇幻',
    categorySlug: 'ke-huan-qi-huan',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20manga%20cover%20art%2C%20a%20spaceship%20approaching%20a%20mysterious%20nebula%2C%20deep%20space%20background%20with%20vibrant%20cosmic%20colors%2C%20cyberpunk%20elements%2C%20a%20female%20astronaut%20in%20sleek%20spacesuit%2C%20Japanese%20seinen%20sci-fi%20style%2C%20cinematic%20lighting%2C%20high%20contrast%2C%20professional%20cover%20design&width=800&height=1100&seq=manga-cover-04&orientation=portrait',
    rating: 4.7,
    ratingCount: 1543,
    description: '公元2278年，人类在星际殖民中发现了"星渊"——一个蕴含无限能源的神秘空间裂隙。探险船"地平线号"奉命深入调查，却意外进入了平行宇宙。在那里，船员们必须面对自己内心最深处的恐惧与欲望，才能找到回家的路。一部将硬科幻与心理探索完美融合的太空史诗。',
    tags: ['科幻', '太空', '心理', '哲学'],
    publishDate: '2025-11-01',
    chapters: 24,
    status: '连载中',
    featured: false,
    latest: true,
    contentHtml: '<p>警报声在走廊里回荡，红色的应急灯光将每个人的脸照得忽明忽暗。</p><p>"引力异常！所有人系好安全带！"舰长艾伦·莫里森的声音从广播中传来，带着他惯有的冷静——或者说，是那种经历过无数次生死危机后磨练出来的冷静。</p><p>凌霜握紧了座椅扶手，透过舷窗望向外面。那是一片她从未见过的景象：无数光点像水中的涟漪一样在虚空中扩散，形成一道道绚丽的同心圆。在那些光圈的中央，有一个黑色的"洞"——不是黑洞，而是一种更加诡异的存在。</p><p>它不像黑洞那样吞噬一切，反而像是从另一个维度"渗漏"过来的裂缝。</p><p>这就是"星渊"。人类在半个世纪前发现的宇宙中最神秘的现象。</p><p>"进入倒计时，十、九、八……"</p><p>凌霜闭上了眼睛。她是这艘船上最年轻的天体物理学家，今年才二十九岁。按照常规，她根本没有资格参加这种级别的深空任务。但"星渊"的发现改变了所有规则——人类需要最聪明的大脑，无论年龄。</p><p>"一。"</p><p>整个世界翻转了。</p><p>当凌霜再次睁开眼睛时，舷窗外已经不再是她熟悉的宇宙。天空是紫色的，星星像钻石一样镶嵌在天幕上，一动不动。而在不远处的虚空中，漂浮着一座城市——一座由透明水晶构成的、美得不真实的城市。</p>',
  },
  {
    id: '5',
    slug: 'ren-jian-ci-wei',
    title: '人间刺猬',
    author: '赵晚亭',
    category: '艺术写实',
    categorySlug: 'yi-shu-xie-shi',
    coverImage: 'https://readdy.ai/api/search-image?query=Literary%20slice%20of%20life%20manga%20cover%2C%20an%20elderly%20person%20sitting%20alone%20in%20a%20traditional%20Chinese%20courtyard%2C%20autumn%20leaves%20falling%2C%20warm%20melancholic%20tone%2C%20watercolor%20and%20ink%20style%2C%20Japanese%20gekiga%20aesthetic%2C%20emotional%20depth%2C%20soft%20natural%20light%2C%20professional%20cover%20design&width=800&height=1100&seq=manga-cover-05&orientation=portrait',
    rating: 4.9,
    ratingCount: 982,
    description: '一个退休老裁缝的日常，一段跨越半个世纪的记忆。从民国到当代，从江南小镇到繁华都市，一针一线之间缝制的不只是衣裳，更是一个时代的缩影和无数普通人的悲欢离合。画风融合浮世绘与水墨技法，每一页都是可以装裱的艺术品。被誉为"给成年人的一剂温柔"。',
    tags: ['写实', '人生', '治愈', '文学性'],
    publishDate: '2025-03-01',
    chapters: 18,
    status: '已完结',
    featured: true,
    latest: false,
    contentHtml: '<p>老沈今年七十三岁，在苏州平江路的一条巷子里开了四十五年的裁缝铺。</p><p>铺子不大，一进门就是一张老旧的裁衣板，墙上挂着各种颜色的线轴，像一幅抽象的彩虹。角落里有一台蝴蝶牌缝纫机，比老沈的年纪还大，但擦得锃亮，踩起来声音清脆。</p><p>"沈师傅，这条裤子帮改改。"隔壁水果摊的小周探进半个身子，"裤腿太长了，每次走路都踩到。"</p><p>老沈从老花镜上方看了他一眼，接过裤子翻了翻："你这裤子，买了有三年了吧？料子都洗薄了，还改什么改。"</p><p>"这不是省钱嘛。"小周讪笑。</p><p>"省什么省。"老沈嘴上这么说，手上已经开始量尺寸了，"下不为例啊。"</p><p>小周千恩万谢地走了。老沈拿起划粉在裤脚上画线，动作精准得像机器。他的手很稳，七十多岁了，做了一辈子裁缝，这双手从没抖过。</p><p>可今天，他的手抖了一下。</p><p>因为抽屉里那张泛黄的照片，不小心露了一个角出来。</p><p>照片上是两个年轻人，穿着六十年代的衣裳，站在这座裁缝铺的门前，笑得像拥有了整个世界。那个瘦高的小伙子是他，旁边扎着两条麻花辫的姑娘，叫阿珍。</p><p>他曾经的爱人。他这一生，唯一爱过的人。</p>',
  },
  {
    id: '6',
    slug: 'mo-du-kuang-xiang',
    title: '魔都狂想',
    author: '王不羁',
    category: '黑色幽默',
    categorySlug: 'hei-se-you-mo',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20comedy%20satirical%20manga%20cover%2C%20exaggerated%20caricature%20of%20modern%20city%20life%2C%20chaotic%20colorful%20urban%20scene%2C%20absurd%20elements%2C%20pop%20art%20style%20with%20manga%20influence%2C%20vibrant%20contrasting%20colors%2C%20Japanese%20alternative%20manga%20aesthetic%2C%20bold%20graphic%20design%2C%20professional%20cover&width=800&height=1100&seq=manga-cover-06&orientation=portrait',
    rating: 4.5,
    ratingCount: 1278,
    description: '在上海这座"魔都"，每个人都在扮演自己的角色。一个过气音乐人、一个破产富二代、一个退休黑道大哥和一个梦想成为网红的外卖小哥——四个毫不相干的人因为一连串荒诞的巧合走到一起，上演了一出让人笑中带泪的都市荒诞剧。辛辣讽刺，笑料百出，但笑声背后是成年人才懂的心酸。',
    tags: ['幽默', '讽刺', '都市', '荒诞'],
    publishDate: '2025-08-05',
    chapters: 30,
    status: '连载中',
    featured: false,
    latest: true,
    contentHtml: '<p>如果让老马来总结自己前四十年的人生，他会用三个字：全完了。</p><p>音乐梦——完了。当年"台风乐队"的主唱，现在每周三在人民广场地铁站地下通道卖唱，面前摆个二维码，一天最好的成绩是一百二十块。</p><p>婚姻——完了。前妻带着女儿去了深圳，上次视频通话是三个月前，女儿问他："爸爸你什么时候来接我？"他看了一眼自己租的那个十平米的隔断间，说不出话。</p><p>尊严——这个倒没说"完了"，因为不知道什么时候就没的。</p><p>但今天不一样。今天老马站在陆家嘴一栋写字楼的顶层，穿着一套从淘宝花三百块买的"高定西装"，手里端着一杯他叫不出名字的鸡尾酒，面前站着一个自称是"天使人"的投资人。</p><p>这一切是怎么发生的？</p><p>这得从三天前他在垃圾桶边捡到的那张名片说起。</p>',
  },
  {
    id: '7',
    slug: 'ye-wu-jin-tou',
    title: '夜雾尽头',
    author: '林雨轩',
    category: '悬疑惊悚',
    categorySlug: 'xuan-yi-jing-song',
    coverImage: 'https://readdy.ai/api/search-image?query=Psychological%20thriller%20manga%20cover%2C%20a%20foggy%20forest%20at%20twilight%2C%20a%20lone%20figure%20walking%20on%20a%20winding%20path%2C%20eerie%20atmosphere%2C%20muted%20teal%20and%20charcoal%20tones%2C%20Japanese%20seinen%20horror%20style%2C%20atmospheric%20lighting%2C%20high%20detail%2C%20professional%20cover%20design&width=800&height=1100&seq=manga-cover-07&orientation=portrait',
    rating: 4.7,
    ratingCount: 1650,
    description: '一座被浓雾笼罩的北方小镇，三十年前的一起灭门惨案至今未破。记者周念在调查一桩看似普通的失踪案时，意外牵出了当年惨案的惊人真相。浓雾掩盖的不只是视线，还有人心。林雨轩继《暗夜天堂》后的又一力作，悬疑氛围更加浓郁。',
    tags: ['悬疑', '惊悚', '小镇', '推理'],
    publishDate: '2026-01-15',
    chapters: 16,
    status: '连载中',
    featured: false,
    latest: true,
    contentHtml: '<p>雾很大。</p><p>周念把车停在镇口的加油站，下车的时候几乎看不清五米外的东西。十一月的北方小镇，天色暗得早，才下午四点，就已经像是晚上七八点的光景。</p><p>"姑娘，你是外地来的吧？"加油站的老板是个五十多岁的中年男人，操着一口浓重的本地口音，"这雾得等到明天早上才散，你要去哪儿？我劝你今晚就在镇上住下。"</p><p>"白杨镇。"周念说。</p><p>老板的脸色微妙地变了一下。他盯着周念看了几秒，然后笑了，但那笑容不太自然："那你来对了，这儿就是白杨镇。"</p><p>周念点点头。她是《南方深度周刊》的调查记者，这次来白杨镇，表面上是调查一起普通的失踪案——一个叫刘建国的建筑工人，三个月前在回家的路上消失了，活不见人死不见尸。</p><p>但真正让她千里迢迢从广州赶到这个北方小镇的，是刘建国的身份——他是三十年前白杨镇灭门惨案唯一的目击证人。</p><p>那个案子，至今未破。而唯一的证人，在三十年后的今天，也消失了。</p>',
  },
  {
    id: '8',
    slug: 'hong-chen-ke-zhan',
    title: '红尘客栈',
    author: '沈墨白',
    category: '历史传奇',
    categorySlug: 'li-shi-chuan-qi',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20inn%20manga%20cover%2C%20ancient%20Chinese%20tavern%20with%20warm%20lantern%20glow%2C%20travelers%20in%20traditional%20robes%2C%20rainy%20night%20atmosphere%2C%20rich%20earth%20tones%20with%20gold%20accents%2C%20ink%20brush%20art%20style%2C%20atmospheric%20storytelling%2C%20professional%20cover%20design&width=800&height=1100&seq=manga-cover-08&orientation=portrait',
    rating: 4.8,
    ratingCount: 2135,
    description: '南宋末年，一家名为"红尘"的客栈矗立在南北要道之上。在这里，商贾、侠客、逃犯、官员各色人等来来往往，每个人的故事都是一段传奇。客栈老板娘柳如是周旋于各方势力之间，守护着这片乱世中的温暖角落。细腻画风配上宏大叙事，被读者称为"纸上电影"。',
    tags: ['历史', '武侠', '人情', '传奇'],
    publishDate: '2025-06-20',
    chapters: 42,
    status: '连载中',
    featured: false,
    latest: false,
    contentHtml: '<p>三更天的梆子刚敲过，客栈的门被人从外面推开，带进来一阵湿冷的风和几片枯叶。</p><p>柳如是正在柜台后面算账，闻声抬起头来。进来的是三个男人，浑身湿透，看起来赶了不少夜路。为首的那个腰间挂着一把刀，刀鞘上的铜饰在烛光下闪着暗沉的光。</p><p>"还有空房吗？"刀客问，声音沙哑。</p><p>"有。"柳如是放下毛笔，脸上挂着恰到好处的笑容，"一间上房、一间大通铺，客官要哪种？"</p><p>"三间上房。"</p><p>"巧了，正好三间。"柳如是从墙上取下三把钥匙，"楼上请。"</p><p>但她心里清楚，这三个人不是普通的过路客。这兵荒马乱的年头，能随身带刀的只有两种人——官差和亡命徒。而从这三人的神态来看，他们既不像官差那样理直气壮，也不像亡命徒那样草木皆兵。</p><p>他们在害怕，但他们怕的不是追兵。</p><p>他们在怕自己要去的地方。</p><p>柳如是在红尘客栈待了十五年，见过的人比衙门里的卷宗还多。她不需要问，只需要看。</p><p>今夜，注定不太平。</p>',
  },
  {
    id: '9',
    slug: 'bo-li-guan',
    title: '玻璃罐',
    author: '赵晚亭',
    category: '艺术写实',
    categorySlug: 'yi-shu-xie-shi',
    coverImage: 'https://readdy.ai/api/search-image?query=Minimalist%20slice%20of%20life%20manga%20cover%2C%20a%20glass%20jar%20on%20a%20windowsill%20with%20sunlight%20streaming%20through%2C%20quiet%20domestic%20scene%2C%20soft%20pastel%20watercolor%20style%2C%20Japanese%20alternative%20manga%20aesthetic%2C%20nostalgic%20warm%20light%2C%20emotional%20simplicity%2C%20professional%20cover%20design&width=800&height=1100&seq=manga-cover-09&orientation=portrait',
    rating: 4.6,
    ratingCount: 756,
    description: '一个独居女人、一只流浪猫、一罐千纸鹤。看似平淡的日常中，藏着一段不为人知的过往。赵晚亭用她标志性的细腻笔触，描绘了一个关于失去与重生的治愈故事。没有跌宕起伏的剧情，只有生活本身的温柔与坚韧。适合在安静的夜晚，配一杯热茶慢慢品读。',
    tags: ['治愈', '人生', '独居', '文学'],
    publishDate: '2025-12-20',
    chapters: 12,
    status: '已完结',
    featured: false,
    latest: false,
    contentHtml: '<p>她每天早上七点起床，先给自己冲一杯黑咖啡，然后坐在窗边看一会儿外面。</p><p>窗外是一个老旧的小区，有几棵银杏树，秋天的时候会把地面铺成金色。现在是一月，树上光秃秃的，但阳光很好，透过玻璃照进来，在地板上画出一块温暖的光斑。</p><p>那只橘猫就是冲着这块光斑来的。</p><p>它第一次出现是在三个月前。当时她刚搬来这个小区不久，每天除了上班就是待在屋里，几乎不和任何人说话。那天早上她照例坐在窗边喝咖啡，突然看到一个橘色的影子从窗台上跳过去。</p><p>她吓了一跳，但那只猫比她更害怕，嗖的一下就跑了。</p><p>但第二天，它又来了。</p><p>这一次，它在窗台边缘停了几秒，用它那双琥珀色的眼睛透过玻璃看着她。她没动，也没说话，只是安静地回望。</p><p>人和猫就这样对视了大概半分钟。然后它转身走了，尾巴高高翘着，像一个骄傲的逗号。</p><p>第三天，她在窗台上放了一小碟牛奶。</p><p>从那天起，这只橘猫就成了她生活中最稳定的存在。</p>',
  },
  {
    id: '10',
    slug: 'ni-liu-zhe',
    title: '逆流者',
    author: '叶星辰',
    category: '科幻奇幻',
    categorySlug: 'ke-huan-qi-huan',
    coverImage: 'https://readdy.ai/api/search-image?query=Dystopian%20sci-fi%20manga%20cover%2C%20a%20rebel%20standing%20atop%20a%20ruined%20skyscraper%2C%20cyberpunk%20city%20in%20ruins%2C%20neon%20lights%20reflecting%20in%20rain%20puddles%2C%20dark%20atmospheric%20tone%2C%20Japanese%20seinen%20dystopian%20style%2C%20dramatic%20composition%2C%20professional%20cover%20design&width=800&height=1100&seq=manga-cover-10&orientation=portrait',
    rating: 4.5,
    ratingCount: 1089,
    description: '近未来的反乌托邦世界，记忆可以被交易、被篡改、被删除。底层青年程夜在非法记忆黑市中谋生，直到有一天，他收到了一份来自"过去的自己"的记忆——一段他从未经历过的、关于反抗与自由的人生。这段记忆从何而来？他究竟是谁？一场关于记忆、身份与自由的惊险旅程就此展开。',
    tags: ['科幻', '反乌托邦', '动作', '哲学'],
    publishDate: '2026-02-01',
    chapters: 10,
    status: '连载中',
    featured: false,
    latest: true,
    contentHtml: '<p>记忆是最不可靠的东西。</p><p>程夜比任何人都清楚这一点，因为他每天都在买卖别人的记忆。</p><p>在这个时代，记忆不再是私人的、不可侵犯的领地。你可以把自己不想要的痛苦记忆卖掉，换一笔不菲的收入；也可以购买一段"美好人生"——在虚拟的记忆里，你曾经拥有过完美的童年、甜蜜的初恋、辉煌的事业。</p><p>至于那是真实的还是编造的，没人在乎。</p><p>程夜的工作是在"记忆交易所"当掮客。他的职责很简单：从卖家那里收购记忆，经过"交易所"的AI加工处理，再卖给买家。他每完成一单，抽取百分之十五的佣金。</p><p>这份工作谈不上光彩，但足够让他在这个城市活下来。</p><p>今天晚上，他接了一个特殊的单子。一个匿名卖家通过暗网联系他，要求当面交易一份"高级记忆"——所谓高级记忆，就是未经AI篡改的原始数据。这种交易是非法的，但利润极高。</p><p>程夜犹豫了三秒，然后回复了一个"好"。</p><p>他需要钱。这个理由，在这个时代已经足够了。</p>',
  },
];

export const featuredManga = allManga.filter((m) => m.featured);
export const latestManga = allManga.filter((m) => m.latest);
export const completedManga = allManga.filter((m) => m.status === '已完结');